import { h } from 'preact';
import * as BaseComp from 'components/bolt/signUpForm/signUpForm.js';
import Store from 'store/store';
import { geoFromIP } from 'utils/bolt/geo';
import { isInEU } from 'utils/eu';
import { sortObjectByOrder } from 'utils/utils';
import { getCopy } from 'utils/copy';

import s from 'components/bolt/signUpForm/signUpForm.sss';

export default class SignUpForm extends BaseComp.default {
	constructor(props) {
		super(props);
	}

	async componentDidMount() {
		super.componentDidMount();
		const geo = await geoFromIP();
		const userInEU = await isInEU(geo?.countryCode);
		this.setState({ userCountry: geo?.countryCode, userInEU });
	}

	renderDoNotSellLogo() {
		const imageRoot = Store.get().appData?.urls?.roots?.sharedImages || '';
		return <img class={s.doNotSellLogo} src={imageRoot + '/Your_Privacy_Choices.png'} alt="Your privacy choices logo" />;
	}

	renderFooterLinks(links) {
		const { userCountry, userInEU } = this.state;
		if (!userInEU) {
			links = Object.fromEntries(Object.entries(links || {}).filter(([key]) => key !== 'cookies'));
		}
		const sortedLinks = sortObjectByOrder(links);

		return (
			<ul class={s.links}>
				{sortedLinks.map((link, index) => {
					let copy = link.$copy;
					if (link.copyUS && userCountry === 'us') copy = link.copyUS;
					return (
						<li key={index} class={s.linkWrapper}>
							<a href={link.url} target={link.target ? link.target : '_blank'} class={s.footerLink}>
								{link.showPrivacyChoicesLogo && userCountry === 'us' && this.renderDoNotSellLogo()}
								{getCopy(copy, {}, '', null, 'baseCopy') || copy}
							</a>
						</li>
					);
				})}
			</ul>
		);
	}

	render(props, state) {
		const base = super.render(props, state);
		const store = Store.get();
		const formData = store.appData?.options?.formEmbeds?.signUp;
		if (formData?.displayFooterLinks) {
			const footerLinks = Object.values(store.appData?.footer?.defaultFooter?.links || {});
			base.children.splice(1, 0, this.renderFooterLinks(footerLinks));
		}
		return base;
	}
}
